
import WkTableItems from './WkTableItems';

import { objDeepCopy } from '@/utils';
import Emitter from 'element-ui/lib/mixins/emitter';

export default {
  // 明细表格
  name: 'WkDetailTable',

  components: {
    WkFormItems: function WkFormItems() {
      return import('../WkForm/WkFormItems');
    },
    WkTableItems: WkTableItems
  },

  mixins: [Emitter],

  props: {
    title: String,
    showType: {
      type: String,
      default: 'defalut' // defalut table
    },
    propPrefix: String,
    btnName: String,
    addFieldList: Array,
    addFieldForm: Object,
    fieldForm: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fieldList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: Boolean
  },

  data: function data() {
    return {};
  },


  computed: {},

  watch: {},

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    formChange: function formChange(item, index, value, valueList) {
      this.$emit('change', item, index, value, valueList);
      this.dispatch('ElFormItem', 'el.form.change', this.fieldForm);
    },
    addClick: function addClick() {
      this.fieldList.push(objDeepCopy(this.addFieldList));
      this.fieldForm.push(objDeepCopy(this.addFieldForm));
    },
    deleteClick: function deleteClick(index) {
      this.fieldList.splice(index, 1);
      this.fieldForm.splice(index, 1);
    }
  }
};